import axios from 'axios';
import axiosInstance from './axiosInstance';

export async function apiFetch(url, options = {}) {
  const { method = 'GET', headers = {}, body, signal } = options;

  try {
    const response = await axiosInstance({
      url,
      method,
      headers,
      data: body,
      signal,
    });

    const nullBodyStatuses = [101, 103, 204, 205, 304];
    const isNullBody = nullBodyStatuses.includes(response.status);

    const text = isNullBody
      ? null
      : typeof response.data === 'string'
        ? response.data
        : JSON.stringify(response.data);

    return new Response(text, {
      status: response.status,
      headers: new Headers({ 'Content-Type': 'application/json' }),
    });
  } catch (error) {
    if (axios.isCancel(error)) {
      throw new DOMException('Aborted', 'AbortError');
    }

    const status = error.response?.status ?? 500;
    const data = error.response?.data;
    const text = typeof data === 'string' ? data : JSON.stringify(data ?? {});

    return new Response(text, {
      status,
      statusText: error.response?.statusText ?? '',
    });
  }
}
